// @ts-nocheck


import styled from 'styled-components';
import { GridItem as UIGridItem } from '../../../../../../../../../components/layout/Grid';

export const ControlButton = styled.button.withConfig({ displayName: "styles__ControlButton", componentId: "sc-138rzmg-0" })(["background:transparent;border:none;padding:5px;cursor:pointer;outline:none;margin-left:16px;"]);








export const GridItem = styled(UIGridItem).withConfig({ displayName: "styles__GridItem", componentId: "sc-138rzmg-1" })(["display:flex;align-items:center;"]);
